module.exports = __webpack_public_path__ + "media/jingraphics.com.home.4462b268.mp4";